
// Returns the full client url for the current environment
export default function clientUrl(clientSubdomain) {
  const hostName = window.location.host;
  const hostNameSplit = hostName.split('.');
  // A list of domains that cannot be the subdomain
  // (This is used because there may not be a subdomain, E.G. localhost:5000 is valid)
  const invalidClientNames = ['localhost:5000', 'bestige'];
  if (!invalidClientNames.includes(hostNameSplit[0])) {
    // Remove the subdomain
    hostNameSplit.shift();
  }
  const hostWithoutSubdomain = hostNameSplit.join('.');
  // Use http for local development, so that developers do not need to setup certificates
  // (This will likely change in the future, see https://docs.microsoft.com/en-us/aspnet/core/security/enforcing-ssl?view=aspnetcore-2.2)
  let protocol = 'https';
  if (hostWithoutSubdomain.startsWith('localhost:5000')) {
    protocol = 'http';
  }

  return `${protocol}://${clientSubdomain}.${hostWithoutSubdomain}`;
}
